import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, useCallback, useEffect, useState } from 'react';
import useRefHeight from 'syf-js-utilities/hooks/useRefHeight';
import { CollapseBodyWrapper, CollapseContainer } from './subcomponents';
export const collapseDuration = 0.6;
const Collapse = ({ id, className, children, duration = collapseDuration, expand = false }) => {
    const divRef = createRef();
    const height = useRefHeight(divRef);
    const timeOutDuration = duration * 1000;
    const [transitionHasEnded, setTransitionHasEnded] = useState(false);
    const onTransitionHasEnded = useCallback(() => {
        return setTimeout(() => {
            setTransitionHasEnded(expand);
        }, timeOutDuration);
    }, [expand, timeOutDuration]);
    useEffect(() => {
        const transitionId = onTransitionHasEnded();
        return () => {
            clearTimeout(transitionId);
        };
    }, [expand, onTransitionHasEnded]);
    return (_jsx(CollapseBodyWrapper, Object.assign({ id: id, "aria-hidden": !expand, className: className, "$isExpanded": expand, "$duration": duration, "$transitionHasEnded": transitionHasEnded, "$height": height }, { children: _jsx(CollapseContainer, Object.assign({ "$isExpanded": expand, "$duration": duration, ref: divRef }, { children: children })) })));
};
export default Collapse;
